import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { INofesh } from "../../nofesh/model/nofesh";
import { ENofeshType } from "../enums/enofesh-type.enum";


@Injectable({
    providedIn: "root"
})
export class MishpachotChulCanActivateGuard implements CanActivate
{
    // Nofshonim and mishpachot chul are sharing the same components and logic.
    // This guard's porpose is to check if the user is navigating to the right url.


    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean
    {
        let canActivate: boolean = false;
        let idNofesh: number = (next.children.length > 0) ? next.children[0].params.id : 0;
        let nofashim: INofesh[] = JSON.parse(sessionStorage.getItem("nofashim"));
        if(nofashim && idNofesh > 0)
        {
            let nofesh: INofesh = nofashim.find(n => n.id_nofesh == idNofesh && n.nofeshType === ENofeshType.MishpachotChul);
            if(nofesh)
            {
                canActivate = true;
            }
        }
        return canActivate;
    }
}